import { useEffect, useState } from 'react';

import type { FC } from 'react';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

import { InstallmentCalculatorDialog } from '@packages/installment-calculator/src/installmentCalculator/InstallmentCalculatorDialog';
import type { Config } from '@packages/config/src/default/types';
import type { Layout1Props } from '../Layout1';
import { Layout1 } from '../Layout1';
import type { Layout2Props } from '../Layout2';
import { Layout2 } from '../Layout2';
import type { Layout3Props } from '../Layout3';
import { Layout3 } from '../Layout3';
import { useInstallmentCalculatorTracking } from '../../../Tracking/hooks/useInstallmentCalculatorTracking';

export type InstallmentCalulatorInDialogProps = {
  /**
   * the single installment value from the calculation result as integer (e.g. 1337)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the number of installments from the calculation result
   */
  numberOfInstallments: number;
  /**
   * Product price value as int (e.g. 1337)
   */
  basePrice: number;
};

export const InstallmentCalulatorInDialog: FC<InstallmentCalulatorInDialogProps> = ({
  singleInstallment,
  currency,
  numberOfInstallments,
  basePrice,
}) => {
  const [dialogOpened, setDialogOpened] = useState(false);
  const {
    installmentCalculator: { InstallmentCalculatorCallToActionLayout },
  } = useConfig();

  const { trackGlycerinDisplayLink } = useInstallmentCalculatorTracking();

  useEffect(() => {
    trackGlycerinDisplayLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!InstallmentCalculatorCallToActionLayout) {
    return null;
  }

  const componentProps: Layout1Props | Layout2Props | Layout3Props = {
    singleInstallment,
    currency,
    openInstallmentCalulatorHandler: () => setDialogOpened(true),
  };

  const renderLayout = (
    layout: NonNullable<
      Config['installmentCalculator']['InstallmentCalculatorCallToActionLayout']
    >['layout'],
  ) => {
    switch (layout) {
      case 'Layout1':
        return <Layout1 {...componentProps} numberOfInstallments={numberOfInstallments} />;
      case 'Layout2':
        return <Layout2 {...componentProps} numberOfInstallments={numberOfInstallments} />;
      case 'Layout3':
        return <Layout3 {...componentProps} />;
      default:
        return null; // just in case someone adds more layouts later
    }
  };

  return (
    <>
      <InstallmentCalculatorDialog
        basePrice={basePrice}
        open={dialogOpened}
        handleClose={() => setDialogOpened(false)}
        displayTrackingProps={{ category: 'Ratenrechner', label: 'Kredit-Promo' }}
      />
      {renderLayout(InstallmentCalculatorCallToActionLayout.layout)}
    </>
  );
};
